export default {
  state: {
    blueprints: [],
    records: []
  },

  mutations: {
    updateBlueprints(state, blueprints) {
      state.blueprints = blueprints
    },
    updateRecords(state, records) {
      state.records = records
    }
  },

  actions: {
    async getBlueprints({ commit }) {
      try {
        const response = await this._vm.$http.get(`flow/blueprints`)
        commit('updateBlueprints', response.data.blueprints)
      } catch (error) {
        console.log(error)
      }
    },
    async getRecords({ commit }, payload) {
      try {
        console.log('getRecords', payload.start, payload.end)
        const response = await this._vm.$http.get(`flow/blueprints/${payload.blueprintid}/records?start=${payload.start}&end=${payload.end}`)
        commit('updateRecords', response.data.records)
      } catch (error) {
        console.log(error)
      }
    },
  },

  getters: {
    blueprints(state) {
      return state.blueprints
    },
    records(state) {
      return state.records
    }
  }
}
